var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-bar"},_vm._l((_vm.languages),function(lang){return _c('button',{key:lang.code,staticClass:"lang-pill",class:{ active: _vm.current === lang.code },attrs:{"type":"button"},on:{"click":function($event){return _vm.select(lang.code)}}},[_vm._v(" "+_vm._s(_vm.nativeName(lang.code))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }